import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-arm-details-view',
  templateUrl: './new-arm-details-view.component.html',
  styleUrls: ['./new-arm-details-view.component.css']
})
export class NewArmDetailsViewComponent implements OnInit {
  title="Add Arms Detail";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/arm-details/new-arm-details-view/new-arm-details-view.component.ts